module.exports = __webpack_public_path__ + "static/media/history.8c2c9018.svg";